import { render } from "./BuildingForm.vue?vue&type=template&id=242ec889&scoped=true"
import script from "./BuildingForm.vue?vue&type=script&lang=js"
export * from "./BuildingForm.vue?vue&type=script&lang=js"

import "./BuildingForm.vue?vue&type=style&index=0&id=242ec889&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242ec889"]])

export default __exports__